export default __webpack_public_path__ + "static/media/profile.23e5a684.jpg";